import { foldInstrumentName } from "./dials";

const GLYPHS: { test: RegExp; glyph: string }[] = [
  { test: /ukulele|^uke$/, glyph: "🎸" },
  { test: /banjo/, glyph: "🪕" },
  { test: /guitar|bassinst|bassinstrument/, glyph: "🎸" },
  { test: /piano|keys|keyboard/, glyph: "🎹" },
  { test: /organ|hammond/, glyph: "🎹" },
  { test: /synth/, glyph: "🎛️" },
  { test: /saxophone|^sax|altosax|tenorsax/, glyph: "🎷" },
  { test: /trumpet/, glyph: "🎺" },
  { test: /harmonica|bluesharp/, glyph: "🎶" },
  { test: /accordion/, glyph: "🪗" },
  { test: /violin|fiddle|cello|strings/, glyph: "🎻" },
  { test: /harp/, glyph: "💫" },
  { test: /flute|oboe|bagpipe|pipe/, glyph: "🪈" },
  { test: /sitar|koto|tanpura/, glyph: "🪕" },
  { test: /didger|digeri|disiri|didjer/, glyph: "🪵" },
  { test: /tabla|handpan|hangdrum|steeldrum|steelpan|framedrum/, glyph: "🥁" },
  { test: /kick|snare|hats|hat|drum/, glyph: "🥁" },
  { test: /gong/, glyph: "🛎️" },
  { test: /crystalbowl/, glyph: "💎" },
  { test: /singingbowl|bowl/, glyph: "🥣" },
  { test: /tuningfork|fork/, glyph: "🔔" },
  { test: /chime|koshi/, glyph: "🎐" },
  { test: /rainstick/, glyph: "🌧️" },
  { test: /pads?$/, glyph: "🌊" },
  { test: /^fx|riser/, glyph: "✨" },
  { test: /vocal|choir|harmony|adlib|double|whisper/, glyph: "🎤" },
];

export function instrumentGlyph(name: string): string {
  const fold = foldInstrumentName(name);
  if (!fold) return "🎵";
  const hit = GLYPHS.find((g) => g.test.test(fold));
  return hit?.glyph || "🎵";
}
